import React, { createContext, useCallback, useState } from 'react';
import { runCtmWhenReady } from '~/shared/lib/run-ctm';

export const GeoLocationContext = createContext(null);

export const GeoLocationProvider = ({ children }) => {
  let [location, setLocation] = useState('');

  const updateLocation = useCallback((locationValue) => {
    setLocation(locationValue);
    runCtmWhenReady();
  }, []);

  return <GeoLocationContext.Provider value={{ location, updateLocation }}>{children}</GeoLocationContext.Provider>;
};
